import { useEffect } from "react";
import { Hero } from "@/components/landing/Hero";
import { VslSection } from "@/components/landing/VslSection";
import { ProblemSection } from "@/components/landing/ProblemSection";
import { MethodSection } from "@/components/landing/MethodSection";
import { AppPlanSection } from "@/components/landing/AppPlanSection";
import { CommunityPlanSection } from "@/components/landing/CommunityPlanSection";
import { TestimonialsSection } from "@/components/landing/TestimonialsSection";
import { OfferSummary } from "@/components/landing/OfferSummary";
import { ComparisonTable } from "@/components/landing/ComparisonTable";
import { StripeTrust } from "@/components/landing/StripeTrust";
import { PostPaymentSteps } from "@/components/landing/PostPaymentSteps";
import { AboutFounders } from "@/components/landing/AboutFounders";
import { WhatWeAreNot } from "@/components/landing/WhatWeAreNot";
import { FaqSection } from "@/components/landing/FaqSection";
import { FinalCta } from "@/components/landing/FinalCta";
import { Footer } from "@/components/landing/Footer";
import { FAQ_ITEMS } from "@/data/faq";

export default function LandingPage() {
  useEffect(() => {
    const faqJsonLd = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQ_ITEMS.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "faq-jsonld";
    script.text = JSON.stringify(faqJsonLd);
    document.head.appendChild(script);
    return () => {
      document.getElementById("faq-jsonld")?.remove();
    };
  }, []);

  return (
    <main data-testid="landing-page">
      <Hero />
      <VslSection />
      <ProblemSection />
      <MethodSection />
      <AppPlanSection />
      <CommunityPlanSection />
      <TestimonialsSection />
      <OfferSummary />
      <ComparisonTable />
      <StripeTrust />
      <PostPaymentSteps />
      <AboutFounders />
      <WhatWeAreNot />
      <FaqSection />
      <FinalCta />
      <Footer />
    </main>
  );
}
